<template>
  <v-container fluid>
    <v-layout row class="mb-2">
      <v-flex xs12 md6 lg12>
        <span class="headline">和潤進件管理</span>
      </v-flex>
    </v-layout>
    <list-editor
      :column-keys="columnKeys"
      :items="items"
      :loading="loading"
      :showSearchBar="true"
      :showAddButton="true"
      :simple-import-loading="simpleImportLoading"
      :show-simple-add-button="true"
      :showSearchDate="true"
      :showExportButton="true"
      :searchPlaceHolder="searchPlaceHolder"
      :totalItems="getTotalItems"
      :startDate="startDate"
      :endDate="endDate"
      :sourceName="sourceName"
      :getSearchKeys="searchKeys"
      :show-select="false"
      @addData="addData"
      @addSimpleData="addSimpleData"
      @simpleImportData="sampleImportList"
      @editData="edit"
      @questionData="questionData"
      @saveData="save"
      @searchData="searchData"
      @printData="printData"
      @pageView="pageView"
      @uploadData="uploadData"
      @uploadFileData="uploadFileData"
      @changePage="changePage"
      @changeStatus="changeStatus"
      @changeCaseView="changeCaseView"
      @exportData="exportData"
      @importData="importData"
      @removeData="removeData"
      @priorityData="priorityData"
      @handleLoadData="handleLoadData"
    ></list-editor>

    <!--其他工具-彈窗-->
    <FinanceCreditDialog
      :item="editedItem"
      :row-item="rowItemInfo"
      :visible="toolDialog.visible"
      :platform="1"
      @showEvent="toolEvent"
      @closeEvent="toolDialog.visible = false"
      @confirmEvent="toolDialog.visible = false"
    ></FinanceCreditDialog>

    <!--列印-彈窗-->
    <PrintDialog :visible="printDialog.visible"
                 :item="editedItem"
                 :width="isMobile ? '90%' : '50%'"
                 @showEvent="printCreditView"
                 @confirmEvent="printDialog.visible = false">
    </PrintDialog>

    <v-dialog
      v-model="pageDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title class="headline">
          {{pageDialog.title}}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout  justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="productName" :label="`商品名稱`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout  justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="carId" :label="`型號規格`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout  justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="bankName" :label="`銀行名稱`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout  justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="bankSubName" :label="`分行名稱`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout  justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="bankAccount" :label="`銀行帳號`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="hasBeforeBank" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="beforeBankName" :label="`前貸銀行名稱`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="hasBeforeBank" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="beforeName" :label="`前貸銀行戶名`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="hasBeforeBank" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="beforeBankSubName" :label="`前貸分行名稱`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="hasBeforeBank" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="beforeBankAccount" :label="`前貸銀行帳號`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="contractAddress" :label="`買方地址`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs6>
              <v-btn class="primary" dark text  @click="showPageView(0)">指示付款同意書</v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn class="primary" dark text  @click="showPageView(1)">買賣契約</v-btn>
            </v-flex>
          </v-layout>
          <v-layout xs12>
            <v-flex xs6>
              <v-btn class="primary" dark text  @click="showPageView(2)">指示付款同意書-套印</v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn class="primary" dark text  @click="showPageView(3)">買賣契約-套印</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="pageDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--更新案編-->
    <v-dialog
      v-model="updateDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-text>
          <v-text-field v-model="updateDialog.displayId" :label="`裕富案件編號`"></v-text-field>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red" dark text @click="updateDialog.cancel">取消</v-btn>
          <v-btn class="primary" dark text @click="updateDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--實際撥款金額-->
    <v-dialog
      v-model="updatePriceDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title class="headline">
          <span class="subheading">{{ updatePriceDialog.text }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout  justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <span>變更為已核准需填寫實際撥款金額</span>
            </v-flex>
          </v-layout>
          <v-layout v-if="updatePriceDialog.caseStatus === 6" justify="center" style="margin-bottom: 10px;">
            <v-flex xs3>
              <span>撥款日期</span>
            </v-flex>
            <v-flex xs9>
              <date-time-tool
                :date-info="updatePriceDialog.realDate"
              ></date-time-tool>
            </v-flex>
          </v-layout>
          <v-layout v-if="updatePriceDialog.caseStatus === 6" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="updatePriceDialog.realPrice" :label="`實際撥款金額(元)`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="updatePriceDialog.caseStatus === 3" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="updatePriceDialog.totalPrice" :label="`貸款金額(元)`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="updatePriceDialog.caseStatus === 3" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="updatePriceDialog.installmentsNumber" @input="changeInstallmentsNumber" :placeholder="`請輸入期數`" :label="`期數`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="updatePriceDialog.caseStatus === 3" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field v-model="updatePriceDialog.creditPriceMonth" @input="changeInstallmentsNumber" :placeholder="`請輸入期付金額`" :label="`期付金額(元)`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout v-if="updatePriceDialog.caseStatus === 3" justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <v-text-field readonly v-model="updatePriceDialog.creditPriceMonth" @input="changeInstallmentsNumber" :label="`分期總額(期數X期付金額)`"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout justify="center" style="margin-bottom: 10px;">
            <v-flex>
              <span style="color: red" v-if="updatePriceDialog.eventMessage !== ''">
                {{ updatePriceDialog.eventMessage }}</span
              >
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="red" dark text @click="updatePriceDialog.cancel">取消</v-btn>
          <v-btn class="primary" dark text
            :loading="updatePriceDialog.loading"
            @click="updatePriceDialog.confirm">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>


    <!--圖檔管理-->
    <v-dialog title="圖片上傳" v-model="uploadDialog" :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>圖片上傳</h3>
        </v-card-title>
        <v-card-text>
          <upload-view
            :item-detail="editedItem"
            :uploadType="uploadType"
            :is-official="false"
            :show-upload-button="true"
            @onFinishUpload="onFinishUpload"
          ></upload-view>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--檔案管理-->
    <v-dialog v-model="uploadFileDialog" :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>PDF上傳</h3>
        </v-card-title>
        <v-card-text>
          <upload-file-tool
            :item-detail="editedItem"
            :uploadType="uploadFileType"
            :is-official="false"
            @onFinishUpload="onFinishFileUpload"
          ></upload-file-tool>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!--和潤機車資料-->
    <v-dialog
      v-model="uploadMotorDialog"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>和潤機車資料</h3>
        </v-card-title>
        <v-card-text>
          <update-motor-view
            :item-detail="editedItem"
            :show="uploadMotorDialog"
            @onFinishUpload="updateMotorInfo"
          ></update-motor-view>
        </v-card-text>
      </v-card>
    </v-dialog>

    <priority-credit-view
      v-if="priorityDialog.visible"
      :item="rowItemInfo"
      :visible="priorityDialog.visible"
      @closeDialog="priorityDialog.cancel"
      @onFinishUpload="setPriceInfo"
      @onErrorMessage="priceInfoError"
      @closeEvent="closeDialogView"
    >
    </priority-credit-view>

    <mortgage-dialog
      v-if="mortgageDialog.visible"
      :edited-item="newMortgageItem"
      :visible="mortgageDialog.visible"
      @closeDialog="mortgageDialog.cancel"
      @save="mortgageDialog.confirm"
      @closeEvent="closeDialogView"
    >
    </mortgage-dialog>

    <FinanceOfficialView
      :item-detail="editedItem"
      :visible="showFinanceOfficialView"
      :show-cancel="true"
      :show-c-a20="showCA20"
      @cancelEvent="cancelDialogEvent"
      @saveSuccessEvent="saveOfficialSuccessEvent"
      @saveFailEvent="saveOfficialFailEvent"
    ></FinanceOfficialView>

    <question-view
      :item-detail="editedItem"
      :show-cancel="true"
      :visible="questionDialog.visible"
      @cancelEvent="questionDialog.cancel"
      @saveSuccessEvent="questionDialog.confirm"
      @closeEvent="closeDialogView"
    >
    </question-view>

<!--&lt;!&ndash;申覆紀錄&ndash;&gt;-->
<!--    <exam-view  :item-detail="editedItem"-->
<!--                :show-cancel="true"-->
<!--                :visible="examDialog.visible"-->
<!--                @closeEvent="examDialog.visible = false"-->
<!--    ></exam-view>-->

    <agent-contract-view
      :agent-contract-dialog="agentContractDialog"
      @saveContract="saveContract"
    ></agent-contract-view>

    <!--案件對保資料-->
    <v-dialog
      v-model="insureDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>案件對保資料</h3>
        </v-card-title>
        <v-card-text>
          <case-insure-view
            :item-detail="editedItem"
            :show="insureDialog.visible"
            @saveEvent="insureDialog.confirm"
            @cancelEvent="insureDialog.cancel"
          ></case-insure-view>
        </v-card-text>
      </v-card>
    </v-dialog>

    <case-stetting-view
      :item-detail="editedItem"
      :visible="settingDialog.visible"
      :show-cancel="true"
      @saveSuccessEvent="settingDialog.confirm"
      @cancelEvent="settingDialog.cancel"
    ></case-stetting-view>

    <v-dialog
      v-model="contactDialog.visible"
      no-click-animation
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-title>
          <h3>修改經辦人</h3>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-toolbar dark color="teal">
                <v-toolbar-title>經辦人：</v-toolbar-title>
                <v-autocomplete
                  v-model="selectAgentId"
                  :loading="selectAgentLoading"
                  :items="agentItems"
                  :search-input.sync="searchAgent"
                  cache-items
                  class="mx-4"
                  flat
                  hide-no-data
                  hide-details
                  label="經辦姓名"
                  solo-inverted
                  item-text="displayName"
                  item-value="agentId"
                ></v-autocomplete>
              </v-toolbar>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn class="red" dark text @click="contactDialog.visible = false">取消</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="contactDialog.confirm">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :title="`選擇裕富填寫格式`"
      v-model="applicationDialog.visible"
      :width="isMobile ? '90%' : '60%'">
      <v-card>
        <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn class="primary" dark text @click="applicationDialog.view">裕富申請書</v-btn>
            <v-btn class="primary" dark text @click="applicationDialog.form">裕富表單</v-btn>
          </v-flex>
        </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <loanhfc-dialog
      :visible="loanhfcDialog.visible"
      :category="loanhfcDialog.category"
      @confirmEvent="loanhfcDialog.confirm"
      @showEvent="loanhfcEvent"
      @closeEvent="closeDialogView"
    ></loanhfc-dialog>
    <entrepreneur-dialog
      :visible="entrepreneurDialog.visible"
      :category="entrepreneurDialog.category"
      @confirmEvent="entrepreneurDialog.confirm"
      @showEvent="entrepreneurEvent"
      @closeEvent="closeDialogView"
    ></entrepreneur-dialog>
    <ca-dialog
      :visible="caDialog.visible"
      :category="caDialog.category"
      @confirmEvent="caDialog.confirm"
      @showEvent="caEvent"
      @closeEvent="closeDialogView"
    ></ca-dialog>
    <installment-payment-dialog
      :title="installmentDialog.title"
      :visible="installmentDialog.visible"
      :displayId="editedItem.displayId"
      :cellphone="editedItem.customer ? editedItem.customer.cellphone : ''"
      :editIndex="installmentDialog.editIndex"
      @closeEvent="closeDialogView"
      ></installment-payment-dialog>

    <!--簡易進件-->
    <simple-apply-dialog :visible="simpleDialog.visible"   @confirmEvent="simpleDialog.confirm"
                         @cancelEvent="simpleDialog.visible = false"></simple-apply-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import {
  getNow,
  getFinanceUrl,
  getCurrentDate,
  customFormatDate,
  exportFileToBlobUrl,
  installmentOnlineList,
  getCreditLoanFiles
} from "../utils/tool";
import ListEditor from "../../components/ListEditor";
import dateTimeTool from "../../components/dateTimeTool";
import UploadView from "../../components/UploadView";
import UploadFileTool from "../../components/uploadFileTool";
import FinanceOfficialView from "../../components/FinanceOfficialView";
import MortgageDialog from "../../components/MortgageDialog";
import QuestionView from "../../components/QuestionView";
import AgentContractView from "../../components/AgentContractView";
import UpdateMotorView from "../../components/UpdateMotorView";
import LaonhfcModel from "../../models/LaonhfcModel";
import PaymentInfoModel from "../../models/PaymentInfoModel";
import CaseInsureModel from "../../models/CaseInsureModel";
import CaseInsureView from "../../components/CaseInsureView";
import CaseStettingView from "../../components/CaseStettingView";
import LoanhfcDialog from "../../components/LoanhfcDialog";
import EntrepreneurDialog from "../../components/EntrepreneurDialog";
import PriorityCreditView from "../../components/PriorityCreditView";
import common from "@/mixins/common";
import CaDialog from "../../components/CaDialog.vue";
import installmentPaymentDialog from '../../components/InstallmentPaymentDialog';
import ApplicationModel from '../../models/ApplicationModel';
import FinanceCreditDialog from '../../components/FinanceCreditDialog';
import PrintDialog from './PrintDialog';
import AlertView from '@/components/AlertView';
import ExamView from '@/components/ExamView';
import SimpleApplyDialog from '@/components/SimpleApplyDialog';

const priceData = require("../../assets/credit_price");
const cityList = require("../../assets/taiwan_city");
const bankCodeList = require("../../assets/bank_data.json");

export default {
  name: "LoanhfcCreditList",
  components: {
    ExamView,
    PrintDialog,
    FinanceCreditDialog,
    ListEditor,
    dateTimeTool,
    UploadView,
    UploadFileTool,
    FinanceOfficialView,
    MortgageDialog,
    QuestionView,
    AgentContractView,
    UpdateMotorView,
    CaseInsureView,
    CaseStettingView,
    LoanhfcDialog,
    EntrepreneurDialog,
    PriorityCreditView,
    CaDialog,
    installmentPaymentDialog,
    AlertView,
    SimpleApplyDialog
  },
  data() {
    return {
      sourceName: "LoanhfcCreditList",
      selectAgentLoading: false,
      selectAgentId: null,
      searchAgent: null,
      agentItems: [],
      simpleImportLoading: false,
      simpleDialog: {
        title: '',
        visible: false,
        editIndex: 0,
        confirm: () => {},
        cancel: () => {},
      },
      financeCountInfo: {
        today: 0,
        month: 0,
      },
      vendor: {
        contactName: "",
        contactPhone: "",
      },
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      startDate: "",
      endDate: "",
      searchKey: "",
      searchValue: "",
      searchPlaceHolder: "搜尋身分證、姓名、申辦人員",
      uploadDialog: false,
      uploadType: "add",
      uploadFileDialog: false,
      uploadMotorDialog: false,
      installmentDialog: {
        title: '',
        visible: false,
        editIndex: 0,
        confirm: () => {},
        cancel: () => {},
      },
      entrepreneurDialog: {
        visible: false,
        category: 0,
        confirm: () => {},
        cancel: () => {},
      },
      loanhfcDialog: {
        visible: false,
        category: 0,
        confirm: () => {},
        cancel: () => {},
      },
      examDialog: {
        visible: false,
        category: 0,
        confirm: () => {},
        cancel: () => {},
      },
      caDialog: {
        visible: false,
        category: 0,
        confirm: () => {},
        cancel: () => {},
      },
      insureDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      settingDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      contactDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      applicationDialog: {
        visible: false,
        view: () => {},
        form: () => {},
      },
      uploadFileType: "add",
      newMortgageItem: null,
      showFinanceOfficialView: false,
      showCA20: false,
      creditPriceData: priceData,
      cityData: cityList,
      cityList: [],
      areaList: {},
      loading: false,
      fetchCountLoading: false,
      valid: true,
      dialog: false,
      editedIndex: -1,
      editedItem: new ApplicationModel(),
      defaultItem: {
        caseType: 0, // 0優加 1優質 2一般 3借新還舊 4他行代償 5萬物代
        caseId: Math.uuidFast(),
        displayId: "",
        caseName: "機車原融",
        applyDate: {
          year: "",
          month: "",
          day: "",
          isRepublic: false,
          disabled: false,
        },
        approvedDate: {
          year: "",
          month: "",
          day: "",
          isRepublic: false,
          disabled: false,
        },
        name: "",
        memberId: "",
        birthday: {
          year: "",
          month: "",
          day: "",
          isRepublic: true,
        },
        cellphone: "",
        city: "",
        area: "",
        address: "",
        creditPrice: 0, // 貸款金額
        installmentsNumber: 12,
        creditPriceMonth: 0,
        totalCreditPrice: 0, // 總貸金額
        caseStatus: 0, // 0進件中 1婉拒 2待捕
        parentAgent: null,
        confirmAgent: null,
        createDate: getNow(),
        comment: "",
        agentId: "",
        confirmAgentId: "",
      },
      toolDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      printDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      pageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      mortgageDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      priorityDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      questionDialog: {
        title: "",
        text: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      agentContractDialog: {
        title: "",
        text: "",
        caseId: "",
        vendorName: "",
        memberName: "",
        memberId: "",
        bonus: 5,
        auto: false,
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      updateDialog: {
        title: "",
        text: "",
        caseId: "",
        displayId: "",
        visible: false,
        confirm: () => {},
        cancel: () => {},
      },
      updatePriceDialog: {
        title: "",
        text: "",
        caseId: "",
        realPrice: "",
        creditPriceMonth: "",
        installmentsNumber: "",
        totalPrice: "",
        // totalCreditPrice:0,
        caseStatus: 0,
        realDate: {
          year: "",
          month: "",
          day: "",
          isRepublic: true,
        },
        visible: false,
        loading: false,
        eventMessage: "",
        confirm: () => {},
        cancel: () => {},
      },
      search: {
        keyword: "",
      },
      items: [],
      caseId: "",
      productName: "",
      carId: "",
      bankName: "",
      bankSubName: "",
      bankAccount: "",
      beforeBankName: "",
      beforeName: "",
      beforeBankSubName: "",
      beforeBankAccount: "",
      contractAddress: "",
      isShowAllData: false,
      syncToken: "",
      itemInfo: {
        vendor: "",
        name: "",
        publicYear: "",
        publicMonth: "",
        engineId: "",
        cc: "",
        signImage: "",
      },
      timeoutID: null,
      rowItemInfo: {},
      platform: 1,
    };
  },
  created() {
    this.cityData.taiwan.forEach((city) => {
      this.cityList.push(city.city);
      this.areaList[city.city] = city.area;
    });

    const now = new Date();
    this.defaultItem.applyDate.year = `${now.getFullYear()}`;
    this.defaultItem.applyDate.month = `${
      now.getMonth() + 1 < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1
    }`;
    this.defaultItem.applyDate.day = `${
      now.getDate() + 1 < 10 ? `0${now.getDate() + 1}` : now.getDate() + 1
    }`;

    this.fetchAgentList().then(() => {
      this.editedItem.agentId = this.getUserInfo.agentId;
      // this.changeAgent();
    });
    this.loadData();
    this.setDefualtDate();
    this.loadFinanceCountInfo();
  },
  mixins: [common],
  watch: {
    $route(to, from) {
      if (to.path.indexOf("FinanceCreditList") > -1) {
        this.timeoutID = setInterval(() => {
          this.loadData();
          console.log(`5分鐘刷新 ${getNow()}`);
        }, 5 * 60 * 1000);
      } else {
        if (this.timeoutID) {
          clearInterval(this.timeoutID);
        }
      }
    },
    searchAgent(val) {
      this.querySelections(val);
    },
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    hasBeforeBank() {
      return this.editedItem.vendor && this.editedItem.vendor.productId === "2";
    },
    getTotalItems() {
      return this.totalItems;
    },
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
    columnKeys() {
      let list = [
        {
          value: "tools",
          text: "編輯",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "print",
          text: "其他工具",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "question",
          text: "細項",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        // { value: 'changeCase', text: '轉和潤', sortable: false  ,required: false , isShow:true, isEdit:false},
        {
          value: "priority",
          text: "優撥",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "displayId",
          text: "案件編號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "name",
          text: "申辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "memberId",
          text: "身分證字號",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "vendorName",
          text: "經辦人",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "saveDate",
          text: "儲存日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "caseStatus",
          text: "案件狀態",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "category",
          text: "專案類型",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "caseType",
          text: "顧客評分",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "productName",
          text: "專案名稱",
          sortable: false,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "applyDisplayDate",
          text: "申請日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPrice",
          text: "貸款金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "installmentsNumber",
          text: "總期數",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "creditPriceMonth",
          text: "月付金額",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "createDate",
          text: "建立時間",
          sortable: true,
          required: false,
          disabled: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "approvedDisplayDate",
          text: "撥款日期",
          sortable: true,
          required: true,
          isShow: true,
          isEdit: true,
        },
        {
          value: "realPrice",
          text: "實際撥款金額",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "bonus",
          text: "佣金",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "settingPrice",
          text: "設定費",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "comment",
          text: "備註",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: true,
        },
        {
          value: "delete",
          text: "刪除",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
        {
          value: "edit",
          text: "編輯",
          sortable: false,
          required: false,
          isShow: true,
          isEdit: false,
        },
      ];
      if (this.isAdmin) {
        return list;
      } else if (this.getUserInfo.enableLoanhfc === true) {
        return list.filter((m) => m.value !== "delete");
      }
      return list.filter(
        (m) => m.value !== "changeCase" && m.value !== "delete"
      );
    },
    searchKeys() {
      return [
        { key: "name", value: "姓名" },
        { key: "memberId", value: "身分證字號" },
        { key: "vendorName", value: "經辦人姓名" },
        { key: "displayId", value: "案件編號" },
      ];
    },
    getCreditPriceList() {
      const list = [];
      for (let i = 40000; i <= 200000; i += 10000) {
        list.push(i);
      }
      return list;
    },
    getInstallmentsNumberList() {
      return [12, 15, 18, 20, 24];
    },
    dialogKeys() {
      return this.columnKeys.filter((m) => m.value !== "tools");
    },
    isAdmin() {
      return this.getUserInfo.authority === "admin";
    },
    getCaseType() {
      // //0優加 1優質 2一般 3借新還舊 4他行代償 5萬物代
      return [
        { key: 0, value: "優加" },
        { key: 1, value: "優質" },
        { key: 2, value: "一般" },
        { key: 3, value: "借新還舊" },
        { key: 4, value: "他行代償" },
        { key: 5, value: "萬物代" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "fetchFinanceCreditList",
      "getFinanceCreditNewList",
      "getFinanceCreditList",
      "loginAgentService",
      "saveFinanceCreditData",
      "saveFinanceInfo",
      "removeFinanceCreditData",
      "fetchAgentList",
      "fetchCreditProductInfo",
      "saveCreditProduct",
      "syncCreditProductStatus",
      "updateCaseId",
      "getFinanceCountInfo",
      "updateRealPrice",
      "saveContactInfo",
      "saveMultiResult",
      "deleteCaseInfo",
      "getFinanceOfficialData",
      "savePriceInfo",
      "updatePriceInfo",
      "updatePriceInfoStatus",
      "queryAppropriation",
      "queryCaseStatus",
      "saveRealPrice",
      'saveExportLog'
    ]),
    querySelections(v) {
      this.selectAgentLoading = true;
      this.agentItems = this.getAgentList;
      this.agentItems = this.getAgentList.filter((e) => {
        return (
          (e.displayName || "").toLowerCase().indexOf((v || "").toLowerCase()) >
          -1
        );
      });
      this.selectAgentLoading = false;
    },
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    changeInstallmentsNumber() {
      this.updatePriceDialog.totalCreditPrice = parseInt(this.updatePriceDialog.installmentsNumber) * parseInt(this.updatePriceDialog.creditPriceMonth)
    },
    changeAgent() {
      const find = this.getAgentList.find(
        (agent) => agent.agentId === this.editedItem.agentId
      );
      if (find) {
        if (find.authority === "admin") {
          this.$set(this.editedItem, "parentAgent", {
            agentId: find.agentId,
            agentNumber: find.agentNumber ? find.agentNumber : find.agentId,
            displayName: find.displayName ? find.displayName : find.email,
            parentAgent: find.parentAgent ? find.parentAgent : find.agentId,
            salesName: find.salesName ? find.salesName : find.email,
            cellphone: find.cellphone ? find.cellphone : "",
          });
        } else {
          this.$set(this.editedItem, "parentAgent", {
            agentId: find.agentId,
            agentNumber: find.agentNumber,
            displayName: find.displayName,
            parentAgent: find.parentAgent,
            salesName: find.salesName,
            cellphone: find.cellphone,
          });
        }
      }
    },
    changePage(page) {
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData();
    },
    async loadData() {
      this.loading = true;
      const loginResult = await this.loginAgentService({
        email: this.getUserInfo.email,
      });
      this.syncToken = loginResult.data.data.token;
      // console.log(`loginResult.data == ${JSON.stringify(loginResult.data)}`);
      let searchQuery = [{ "key" :"platform" , "value":`${this.platform}` }]
      if(this.searchKey && this.searchValue) {
        searchQuery.push({ "key" :`${this.searchKey}`, "value":`${this.searchValue}` })
      }
      const results = await this.getFinanceCreditNewList({
        token: this.syncToken,
        agentId: this.isAdmin ? "" : this.getUserInfo.agentId,
        email: this.getUserInfo.email,
        startDate: `${this.startDate} 00:00:00`,
        endDate: `${this.endDate} 23:59:59`,
        pageIndex: this.pageIndex,
        limit: this.limit,
        searchQuery: searchQuery
      });
      this.items = results.data.data.list;
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
      console.log(`items === ${JSON.stringify(this.items)}`);
    },
    async importData(data) {
      this.loading = true;
      let title = "錯誤";
      let message = "";
      try {
        const res = await this.saveMultiResult({
          list: data,
        });
        const saveResult = res.data;
        this.loading = false;
        if (saveResult) {
          if (saveResult.statusCode === 0) {
            title = "成功";
          }
          console.log(JSON.stringify(saveResult));
          message = saveResult.message;
        }
      } catch (e) {
        this.loading = false;
        message = `發生錯誤 ${e}`;
      }

      this.showMessageDialog(
        title,
        message,
        true,
        () => {},
        () => {}
      );
    },
    async removeData(data) {
      // 刪除案件
      this.messageDialog.showCancelButton = true;
      this.showMessageDialog(
        "提示",
        "確定要此案件刪除？（刪除後將無法復原）",
        true,
        async () => {
          this.messageDialog.showCancelButton = false;

          const res = await this.deleteCaseInfo({ caseId: data.caseId });
          const result = res.data;
          if (result.statusCode === 0) {
            this.loadData();
          } else {
            this.showMessageDialog(
              "錯誤",
              result.message,
              true,
              () => {},
              () => {}
            );
          }
        },
        () => {
          this.messageDialog.showCancelButton = false;
        }
      );
    },
    async exportData() {
      this.loading = true;
      let searchQuery = [{ "key" :"platform" , "value":`${this.platform}` }]
      if(this.searchKey && this.searchValue) {
        searchQuery.push({ "key" :`${this.searchKey}`, "value":`${this.searchValue}` })
      }
      const query = {
        token: this.syncToken,
        agentId: this.isAdmin ? "" : this.getUserInfo.agentId,
        startDate: this.startDate,
        endDate: this.endDate,
        pageIndex: 1,
        limit: 10000,
        platform: this.platform,
        searchQuery: searchQuery
      }
      this.saveExportLog({
        searchContent: JSON.stringify(query),
        agentId: this.getUserInfo.agentId,
        email: this.getUserInfo.email,
        displayName: this.getUserInfo.displayName,
      });

      if (this.getUserInfo.enableExport === true || this.isAdmin || this.isManager){
        const results = await this.getFinanceCreditNewList(query);
        let columns = [];
        const list = this.columnKeys.filter((m) => m.isEdit);
        list.forEach((info) => {
          const itemInfo = {
            name: info.text,
            key: info.value,
          };
          columns.push(itemInfo);
        });
        const resultList = results.data.data.list;
        for (let i in resultList) {
          let resultItemInfo = resultList[i]
          if (resultItemInfo.category === 2 && resultItemInfo.productId === "0") {
            resultItemInfo.productName = "商品貸原融";
          }
        }
        exportFileToBlobUrl("原融進件匯出列表", columns, resultList);
        this.loading = false;
      }

    },
    addData() {
      this.createLink(4);
    },
    addSimpleData(){
      this.simpleDialog.visible = true;
      this.simpleDialog.confirm = (profile)=>{
        console.log(`add simple ${JSON.stringify(profile)}`);
        this.editedItem = new ApplicationModel();
        this.editedItem.customer.name = profile.name;
        this.editedItem.customer.memberId = profile.memberId;
        this.editedItem.carInfo.carId = profile.carId;
        this.editedItem.category = 4;
        this.editedItem.platform = this.platform;
        if(profile.imageList){
          this.editedItem.imageList = profile.imageList;
        }
        this.save();
      };
    },
    async sampleImportList(list){
      console.log(`=== sampleImportList ===`);
      this.simpleImportLoading = true;
      for(let item of list){
        if (item.name !=='' &&  item.memberId!==''){
          let editedItem = new ApplicationModel();
          editedItem.customer.name = item.name;
          editedItem.customer.memberId = item.memberId;
          editedItem.carInfo.carId = item.carId;
          editedItem.platform = this.platform;
          editedItem.parentAgent = {
            agentId: this.getUserInfo.agentId,
            agentNumber: this.getUserInfo.agentNumber,
            displayName: this.getUserInfo.displayName,
            parentAgent: this.getUserInfo.parentAgent.agentId
              ? this.getUserInfo.parentAgent.agentId
              : "",
            salesName: this.getUserInfo.salesName
              ? this.getUserInfo.salesName
              : "",
            cellphone: this.getUserInfo.cellphone
              ? this.getUserInfo.cellphone
              : "",
          };

          editedItem.updateDate = getNow();

          const saveData = JSON.parse(JSON.stringify(editedItem));
          await this.syncData(saveData);
          await this.saveFinanceCreditData(saveData);
        }
      }
      console.log(`=== sampleImportList done ${list.length} ===`);
      this.simpleImportLoading = false;
      this.loadData();
    },
    async save() {
      console.log(`list save === 2`);
      if (this.editedIndex === -1) {
        this.editedItem.parentAgent = {
          agentId: this.getUserInfo.agentId,
          agentNumber: this.getUserInfo.agentNumber,
          displayName: this.getUserInfo.displayName,
          parentAgent: this.getUserInfo.parentAgent.agentId
            ? this.getUserInfo.parentAgent.agentId
            : "",
          salesName: this.getUserInfo.salesName
            ? this.getUserInfo.salesName
            : "",
          cellphone: this.getUserInfo.cellphone
            ? this.getUserInfo.cellphone
            : "",
        };
      }

      this.loading = true;
      this.editedItem.updateDate = getNow();

      this.syncData(this.editedItem);

      const results = await this.fetchCreditProductInfo({
        caseId: this.editedItem.caseId,
      });
      if (results && results.length > 0) {
        const item = results[0];
        this.saveFinanceCreditData(item).then(() => {
          this.loading = false;
          this.loadData();
          this.closeDialog();
        });
      } else {
        const json = JSON.parse(JSON.stringify(this.editedItem));
        this.saveFinanceCreditData(json).then(() => {
          this.loading = false;
          this.loadData();
          this.closeDialog();
        });
      }
    },
    edit(item) {
      this.gotoCredit(item, item.category);
    },
    gotoCredit(item, category) {
      this.editedIndex = 0;
      if(category === 2 && !item.platform) {
        item.platform = 1
      }
      const query = {
        caseCategory: category,
        editIndex: 0,
        caseId: item.caseId,
        enable: true,
        agentId: item.agentId,
        platform: item.platform //0裕富 3高踞
      };
      console.log(` gotoCredit === ${JSON.stringify(query)}`)
      // this.$router.push({ path: '/EditCreditProduct', query });
      let routeData = this.$router.resolve({
        path: "/EditCreditProduct",
        query: query,
      });
      window.open(routeData.href, "_blank");
    },
    getBankInfo(key, subId) {
      let bankCopyList = JSON.parse(JSON.stringify(bankCodeList));
      const info = bankCopyList[key];
      return info;
    },
    async toolEvent(option) {
      const index = option.key;
      console.log(`toolEvent === ${JSON.stringify(option)}`);
     if (index === 1) {
        const officialItem = await this.getFinanceOfficialData({
          caseId: this.editedItem.caseId,
        });
        console.log(`officialItem === ${JSON.stringify(officialItem)}`);
        if (officialItem) {
          const bankInfo = this.getBankInfo(
            officialItem.bankId,
            officialItem.bankSubId
          );
          console.log(`getBankInfo === ${JSON.stringify(bankInfo)}`);
          this.editedItem.bankName = bankInfo.branch;
          this.bankName = bankInfo.branch;
          const find = bankInfo.child.find(
            (item) =>
              item.code === `${officialItem.bankId}${officialItem.bankSubId}`
          );
          if (find) {
            this.editedItem.bankSubName = find.branch;
            this.bankSubName = find.branch;
          }
        }

        const creditLoanFiles = getCreditLoanFiles(this.editedItem)
        if(creditLoanFiles.length > 0) {
          creditLoanFiles.forEach(item => {
            this.attachmentFile.attachmentFiles.push(item)
          })
        }

        this.pageDialog.visible = true;
        this.pageDialog.confirm = () => {
          this.pageDialog.visible = false;
        };
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 2) {
        this.uploadDialog = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 3) {
        this.uploadFileDialog = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 4) {
        // 原融
        this.showFinanceOfficialView = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 15) {
        // 商品貸
        this.showCA20 = true;
        this.showFinanceOfficialView = true;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
      } else if (index === 5) {
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.agentContractDialog.visible = false;

        // this.$set('newMortgageItem' , );
        this.newMortgageItem = {
          profileId: Math.uuidFast(),
          parentAgent: this.editedItem.parentAgent,
          parentAgentName: this.editedItem.parentAgent.displayName,
          publishDate: "",
          name: this.editedItem.customer.name,
          memberId: this.editedItem.customer.memberId,
          engineId: "",
          startDate: {
            year: "",
            month: "",
            day: "",
            disabled: false,
            isRepublic: true,
          },
          endDate: {
            year: "",
            month: "",
            day: "",
            disabled: false,
            isRepublic: true,
          },
          creditPrice: this.editedItem.vendor.totalCreditPrice,
          createDate: getNow(),
          comment: "",
          city: "",
          area: "",
          address: this.editedItem.customer.home.residenceAddress,
          carYear: "",
          carType: "",
          carId: "",
          carEngineType: "",
          birthday: {
            year: this.editedItem.customer.birthdayInfo.year,
            month: this.editedItem.customer.birthdayInfo.month,
            day: this.editedItem.customer.birthdayInfo.day,
            disabled: false,
            isRepublic: true,
          },
          station: "",
        };
        console.log(
          `showMortgageDialog ${JSON.stringify(this.newMortgageItem)}`
        );
        this.mortgageDialog.visible = true;
        this.mortgageDialog.confirm = () => {
          this.mortgageDialog.visible = false;
          this.showMessageDialog(
            "儲存成功",
            "動產抵押契約書儲存成功",
            true,
            () => {},
            () => {}
          );
        };
        this.mortgageDialog.cancel = () => {
          this.mortgageDialog.visible = false;
        };
      } else if (index === 6) {
        this.mortgageDialog.visible = false;
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.agentContractDialog.visible = true;
        this.agentContractDialog.caseId = this.editedItem.caseId;
        this.agentContractDialog.memberId = this.editedItem.customer.memberId;
        this.agentContractDialog.memberName = this.editedItem.customer.name;
        this.agentContractDialog.cancel = () => {
          this.agentContractDialog.visible = false;
        };
      } else if (index === 7) {
        this.showFinanceOfficialView = false;
        this.toolDialog.visible = false;
        this.mortgageDialog.visible = false;
        this.agentContractDialog.visible = false;
        this.updateDialog.visible = true;
        this.updateDialog.confirm = async () => {
          this.updateDialog.visible = false;

          if (this.updateDialog.displayId === "") {
            return;
          }

          await this.updateCaseId({
            caseId: this.editedItem.caseId,
            displayId: this.updateDialog.displayId,
          });

          this.showMessageDialog(
            "儲存成功",
            "更新案編儲存成功",
            true,
            () => {},
            () => {}
          );
        };
        this.updateDialog.cancel = () => {
          this.updateDialog.visible = false;
        };
      } else if (index === 8) {
        //對保資料
        this.toolDialog.visible = false;
        this.insureDialog.visible = true;
        this.insureDialog.confirm = () => {
          this.insureDialog.visible = false;
          this.loadData();
        };
        this.insureDialog.cancel = () => {
          this.insureDialog.visible = false;
        };
      } else if (index === 9) {
        //設定資料
        this.toolDialog.visible = false;
        this.settingDialog.visible = true;
        console.log(`settingDialog === ${this.settingDialog.visible}`);
        this.settingDialog.confirm = () => {
          this.settingDialog.visible = false;
          this.loadData();
        };
        this.settingDialog.cancel = () => {
          this.settingDialog.visible = false;
        };
      } else if (index === 10) {
        this.contactDialog.visible = true;

        this.contactDialog.confirm = () => {
          const find = this.getAgentList.find(
            (agent) => agent.agentId === this.selectAgentId
          );
          if (find) {
            const postData = {
              caseId: this.editedItem.caseId,
              agentId: find.agentId,
              contactPhone: find.cellphone,
              contactName: find.displayName,
            };
            this.changeContact(postData);
          }
          this.contactDialog.visible = false;
        };
      } else if (index === 0 || index === 11) {
        this.toolDialog.visible = false;
        this.loanhfcDialog.visible = true;
        this.loanhfcDialog.category = this.editedItem.category;
        console.log(`category ${this.loanhfcDialog.category}`);
        this.loanhfcDialog.confirm = () => {
          this.loanhfcDialog.visible = false;
        };
      } else if (index === 12) {
        this.toolDialog.visible = false;
        this.entrepreneurDialog.visible = true;
        this.entrepreneurDialog.category = this.editedItem.category;
        this.entrepreneurDialog.confirm = () => {
          this.entrepreneurDialog.visible = false;
        };
      } else if (index === 13) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isEdit: true,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (index === 14) {
        this.toolDialog.visible = false;
        this.priorityDialog.visible = true;
        this.priorityDialog.confirm = () => {
          this.priorityDialog.visible = false;
        };
        this.priorityDialog.cancel = () => {
          this.priorityDialog.visible = false;
        };
      } else if (index === 16) {
        this.toolDialog.visible = false;
        this.caDialog.visible = true;
        this.caDialog.confirm = () => {
          this.caDialog.visible = false;
        };
        this.caDialog.cancel = () => {
          this.caDialog.visible = false;
        };
      } else if (index === 32) { // 轉原車
       const routeData = this.$router.resolve({
         path: "/EditCreditProduct",
         query: {
           caseId: this.editedItem.caseId,
           caseCategory: 0,
           enable: true,
           editIndex: 0,
         },
       });
       window.open(routeData.href, "_blank");
     }
    },
    async changeContact(data) {
      const result = await this.saveContactInfo(data);
      this.loadData();
    },
    priorityData(item) {
      this.editedItem = item;
      if(!this.editedItem.platform) {
        this.editedItem.platform = 0
      }
      this.rowItemInfo = item;
      this.toolEvent(14);
    },
    // 優撥存檔
    async setPriceInfo(data) {
      const result = await this.savePriceInfo(data);
      this.priorityDialog.visible = false;
      this.showMessageDialog(
        "提示",
        "優撥上傳成功",
        true,
        () => {},
        () => {}
      );
      this.loadData();
    },
    priceInfoError(errorString) {
      this.showMessageDialog(
        "錯誤",
        errorString,
        true,
        () => {},
        () => {}
      );
      return;
    },
    saveContract(data) {
      console.log(`save contract == ${JSON.stringify(data)}`);
      let routeData = this.$router.resolve({
        path: "/AgentContract",
        query: {
          contractId: this.agentContractDialog.caseId,
        },
      });
      window.open(routeData.href, "_blank");
      this.agentContractDialog.visible = false;
    },
    searchData(searchInfo) {
      console.log(`searchData == ${JSON.stringify(searchInfo)}`)
      this.searchKey = searchInfo.searchKey;
      this.startDate = searchInfo.startDate;
      this.endDate = searchInfo.endDate;
      this.searchValue = searchInfo.keyword;
      this.loadData();
    },
    removeProfile() {
      this.showMessageDialog(
        "提示",
        "確定要刪除？",
        true,
        () => {
          this.removeFinanceCreditData(this.editedItem).then(() => {
            this.closeDialog();
          });
        },
        () => {}
      );
    },
    async printData(item) {
      // console.log(`printData item === ${JSON.stringify(item)}`);
      this.rowItemInfo = item;
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId,
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        if(!this.editedItem.platform) {
          this.editedItem.platform = 0
        }
        console.log(`this.editedItem  === ${JSON.stringify(this.editedItem)}`);
        this.toolDialog.visible = true;
      }
    },
    printCreditView(type) {
      if (type === 0) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,

            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 1) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 2) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 3) {
        if (!this.editedItem.laonhfcInfo) {
          this.editedItem.laonhfcInfo = new LaonhfcModel();
        }
        if (!this.editedItem.paymentInfo) {
          this.editedItem.paymentInfo = new PaymentInfoModel();
        }
        if (!this.editedItem.caseInsure) {
          this.editedItem.caseInsure = new CaseInsureModel();
        }
        this.uploadMotorDialog = true;
      } else if (type === 4) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 5) { // CA套印
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: false,
            platform:this.editedItem.platform
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 6) {// CA列印
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: true,
            platform:this.editedItem.platform
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 7) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 7,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 8) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 8,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 9) {
        const routeData = this.$router.resolve({
          name: "EditCreditProduct",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            enable: false,
            agentId: this.getUserInfo.userId,
            editIndex: 0,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 10 || type === 11) {
        this.entrepreneurEvent(type);
      } else {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: this.editedItem.category,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    updateMotorInfo(result) {
      console.log(`onFinishUpload === ${JSON.stringify(result)}`);
      this.uploadMotorDialog = false;
      const routeData = this.$router.resolve({
        name: "CreditProductPrint",
        query: {
          caseId: this.editedItem.caseId,
          caseCategory: 4,
          isPrint: false,
        },
      });
      window.open(routeData.href, "_blank");
    },
    async pageView(item) {
      this.pageDialog.visible = true;
      this.editedItem = item;
      if(!this.editedItem.platform) {
        this.editedItem.platform = 0
      }
      this.productName = this.editedItem.productName;
      this.carId = this.editedItem.carId;
      // console.log(`printData == ${JSON.stringify(item)}`);
    },
    changeCaseView(item) {
      //轉和潤
      this.editedItem = item;
      if(!this.editedItem.platform) {
        this.editedItem.platform = 0
      }
      if (!this.editedItem.laonhfcInfo) {
        this.editedItem.laonhfcInfo = new LaonhfcModel();
      }
      if (!this.editedItem.paymentInfo) {
        this.editedItem.paymentInfo = new PaymentInfoModel();
      }
      if (!this.editedItem.caseInsure) {
        this.editedItem.caseInsure = new CaseInsureModel();
      }
      this.uploadMotorDialog = true;
    },
    async showPageView(type) {
      if (this.productName === "") {
        this.showMessageDialog(
          "提示",
          "請輸入商品名稱",
          true,
          () => {},
          () => {}
        );
        return;
      }

      if (this.carId === "") {
        this.showMessageDialog(
          "提示",
          "請輸入大牌號碼",
          true,
          () => {},
          () => {}
        );
        return;
      }

      const results = await this.fetchCreditProductInfo({
        caseId: this.editedItem.caseId,
      });
      if (results && results.length > 0) {
        const item = results[0];

        item.productName = this.productName;
        item.carId = this.carId;
        item.bankName = this.bankName;
        item.bankSubName = this.bankSubName;
        item.bankAccount = this.bankAccount;
        item.beforeBankName = this.beforeBankName;
        item.beforeName = this.beforeName;
        item.beforeBankSubName = this.beforeBankSubName;
        item.beforeBankAccount = this.beforeBankAccount;
        item.contractAddress = this.contractAddress;

        this.saveCreditProduct(item).then(() => {
          if (type === 0) {
            const routeData = this.$router.resolve({
              name: "ApplyPage",
              query: { caseId: item.caseId },
            });
            window.open(routeData.href, "_blank");
          } else if (type === 1) {
            const routeData = this.$router.resolve({
              name: "Contract",
              query: { caseId: item.caseId },
            });
            window.open(routeData.href, "_blank");
          } else if (type === 2) {
            const routeData = this.$router.resolve({
              name: "ApplyTemplatePage",
              query: { caseId: item.caseId },
            });
            window.open(routeData.href, "_blank");
          } else if (type === 3) {
            const routeData = this.$router.resolve({
              name: "ContractTemplate",
              query: { caseId: item.caseId },
            });
            window.open(routeData.href, "_blank");
          }
        });
      }
    },
    async uploadData(item) {
      console.log(`uploadData == ${JSON.stringify(item)}`);
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId,
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        if(!this.editedItem.platform) {
          this.editedItem.platform = 0
        }
        this.uploadDialog = true;
      }
    },
    onFinishUpload(result) {
      console.log(`onFinishUpload === ${JSON.stringify(result)}`);
      this.uploadDialog = false;
      this.loadData();
    },
    async uploadFileData(item) {
      console.log(`uploadFileData == ${JSON.stringify(item)}`);
      const results = await this.fetchCreditProductInfo({
        caseId: item.caseId,
      });
      if (results && results.length > 0) {
        this.editedItem = results[0];
        if(!this.editedItem.platform) {
          this.editedItem.platform = 0
        }
        this.uploadDialog = true;
      }
    },
    onFinishFileUpload(result) {
      console.log(`onFinishFileUpload === ${JSON.stringify(result)}`);
      this.uploadFileDialog = false;
      this.loadData();
    },
    changeStatus(item) {
      // 變更狀態
      console.log(`change ${JSON.stringify(item)}`);
      this.messageDialog.showCancelButton = true;
      this.updatePriceDialog.caseStatus = item.caseStatus;
      if (item.caseStatus === 3) {
        // 已核准
        this.updatePriceDialog.visible = true;
        this.updatePriceDialog.totalPrice = item.totalPrice;
        this.updatePriceDialog.installmentsNumber = item.installmentsNumber;
        this.updatePriceDialog.creditPriceMonth = item.creditPriceMonth;
        this.changeInstallmentsNumber()
        this.updatePriceDialog.confirm = async () => {
          const totalPrice = parseInt(this.updatePriceDialog.totalPrice);
          if (this.updatePriceDialog.totalPrice === "" || totalPrice === 0) {
            this.updatePriceDialog.totalPrice = "請輸入貸款金額";
            return;
          }
          const installmentsNumber = parseInt(
            this.updatePriceDialog.installmentsNumber
          );
          if (
            this.updatePriceDialog.installmentsNumber === "" ||
            installmentsNumber === 0
          ) {
            this.updatePriceDialog.eventMessage = "請輸入期數";
            return;
          }
          const creditPriceMonth = parseInt(
            this.updatePriceDialog.creditPriceMonth
          );
          if (
            this.updatePriceDialog.creditPriceMonth === "" ||
            creditPriceMonth === 0
          ) {
            this.updatePriceDialog.eventMessage = "請輸入期付金額";
            return;
          }
          this.updatePriceDialog.loading = true;
          const updateData = {
            caseId: item.caseId,
            status: item.caseStatus ? item.caseStatus : 3,
            installmentsNumber,
            creditPriceMonth,
            totalPrice,
          };
          console.log(`save read Price ${JSON.stringify(updateData)}`);
          const res = await this.updateRealPrice(updateData);
          this.updatePriceDialog.loading = false;
          if (res && res.data) {
            console.log(`res ${JSON.stringify(res)}`);
            await this.updateFinanceData({
              caseId: item.caseId,
              info: {
                caseStatus: updateData.status,
                'vendor.installmentsNumber': updateData.installmentsNumber,
                'vendor.creditPriceMonth': updateData.creditPriceMonth,
                'vendor.totalPrice': updateData.totalPrice,
                'vendor.totalCreditPrice': updateData.totalCreditPrice,
              },
            });

            this.loadData();
            this.updatePriceDialog.eventMessage = "更新成功";
            setTimeout(() => {
              this.updatePriceDialog.visible = false;
            }, 2000);
          } else {
            this.updatePriceDialog.eventMessage = res.data
              ? res.data.message
              : "更新失敗";
          }
        };
        this.updatePriceDialog.cancel = () => {
          this.updatePriceDialog.visible = false;
        };
      } else if (item.caseStatus === 6) {
        // 已撥款
        this.updatePriceDialog.visible = true;
        this.updatePriceDialog.confirm = async () => {
          const realPrice = parseInt(this.updatePriceDialog.realPrice);
          if (this.updatePriceDialog.realPrice === "" || realPrice === 0) {
            this.updatePriceDialog.eventMessage = "請輸入撥款金額";
            return;
          }
          if (
            this.updatePriceDialog.realDate.year === "" ||
            this.updatePriceDialog.realDate.month === 0 ||
            this.updatePriceDialog.realDate.day === ""
          ) {
            this.updatePriceDialog.eventMessage = "請正確的撥款日期";
            return;
          }
          this.changeInstallmentsNumber()
          const realDate = `${this.updatePriceDialog.realDate.year}-${this.updatePriceDialog.realDate.month}-${this.updatePriceDialog.realDate.day}`;
          this.updatePriceDialog.loading = true;
          const totalPrice = parseInt(this.updatePriceDialog.totalPrice);
          const updateData = {
            caseId: item.caseId,
            realPrice: this.updatePriceDialog.realPrice,
            realDate: realDate,
            status: item.caseStatus ? item.caseStatus : 3,
            totalPrice,
          };
          console.log(`save read Price ${JSON.stringify(updateData)}`);
          const res = await this.updateRealPrice(updateData);
          this.updatePriceDialog.loading = false;
          if (res && res.data) {
            await this.updateFinanceData({
              caseId: item.caseId,
              info: {
                caseStatus: updateData.status,
                'vendor.installmentsNumber': updateData.installmentsNumber,
                'vendor.creditPriceMonth': updateData.creditPriceMonth,
                'vendor.totalPrice': updateData.totalPrice,
                'vendor.totalCreditPrice': updateData.totalCreditPrice,
              },
            });
            console.log(`res ${JSON.stringify(res)}`);

            const change = {
              token: this.syncToken,
              caseId: updateData.caseId,
              caseStatus: updateData.caseStatus,
            };
            await this.syncCreditProductStatus(change);
            this.loadData();

            this.updatePriceDialog.eventMessage = "更新成功";
            setTimeout(() => {
              this.updatePriceDialog.visible = false;
            }, 2000);
          } else {
            this.updatePriceDialog.eventMessage = res.data
              ? res.data.message
              : "更新失敗";
          }
        };
        this.updatePriceDialog.cancel = () => {
          this.updatePriceDialog.visible = false;
        };
      } else {
        this.showMessageDialog(
          "提示",
          "確認要更改狀態嗎？",
          true,
          async () => {
            console.log("確認更改狀態");

            const change = {
              token: this.syncToken,
              caseId: item.caseId,
              caseStatus: item.caseStatus,
            };
            await this.syncCreditProductStatus(change);
            this.loadData();
          },
          () => {
            console.log("取消更改狀態");
            this.loadData();
          }
        );
      }
    },
    closeDialog() {
      this.loading = false;
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      if(!this.editedItem.platform) {
        this.editedItem.platform = 0
      }
      this.editedIndex = -1;
      this.loadData();
    },
    async syncData(item) {
      item.token = this.syncToken;
      const result = await this.saveFinanceInfo(item);
      console.log(`sync == ${JSON.stringify(result.data)}`);
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    createLink(index) {
      if (index === 0) {
        // 商品
        const link = getFinanceUrl(this.getUserInfo.agentId, 1);
        window.open(link, "_blank");
      }
      if (index === 1) {
        // 原融
        let link = getFinanceUrl(this.getUserInfo.agentId, 0);
        link += "&tab=0";
        window.open(link, "_blank");
      }
      if (index === 7) {
        // 原融-新版
        let link = getFinanceUrl(this.getUserInfo.agentId, 0);
        link += "&tab=1";
        window.open(link, "_blank");
      }
      if (index === 2) {
        // 原融
        let link = getFinanceUrl(this.getUserInfo.agentId, 2);
        link += "&platform=3";
        window.open(link, "_blank");
      }
      if (index === 4) {
        const link = getFinanceUrl(this.getUserInfo.agentId, 4);
        window.open(link, "_blank");
      }
      if (index === 5) {
        const link = getFinanceUrl(this.getUserInfo.agentId, 5);
        window.open(link, "_blank");
      }
      if (index === 6) {
        const link = getFinanceUrl(this.getUserInfo.agentId, 6);
        window.open(link, "_blank");
      }
    },
    shareToLine(index) {
      if (index === 0) {
        // 商品
        const link = getFinanceUrl(this.getUserInfo.agentId, 1);
        const line = new LineShare();
        line.share(link);
      }
      if (index === 1) {
        // 原融
        const link = getFinanceUrl(this.getUserInfo.agentId, 0);
        const line = new LineShare();
        line.share(link);
      }
    },
    showAllData() {
      this.isShowAllData = !this.isShowAllData;
      this.loadData();
    },
    saveOfficialSuccessEvent(result) {
      this.showMessageDialog(
        "提示",
        `進件成功! 案件編號為：${result.data.examineNo}`,
        true,
        () => {
          this.showFinanceOfficialView = false;
        },
        () => {}
      );
    },
    saveOfficialFailEvent(result) {
      this.showMessageDialog(
        "提示",
        `進件發生錯誤! 原因：${result.data.msg}`,
        true,
        () => {},
        () => {}
      );
    },
    cancelDialogEvent() {
      this.showFinanceOfficialView = false;
    },
    questionData(item) {
      console.log(`questionData ${JSON.stringify(item)}`);
      this.editedItem = item;
      if(!this.editedItem.platform) {
        this.editedItem.platform = 0
      }
      this.showQuestionView();
    },
    showQuestionView() {
      this.questionDialog.visible = true;
      this.questionDialog.cancel = () => {
        this.questionDialog.visible = false;
      };
      this.questionDialog.confirm = (result) => {
        this.questionDialog.visible = false;
        let title = "錯誤";
        if (result.statusCode === 0) {
          title = "成功";
        }
        this.showMessageDialog(
          title,
          result.message,
          true,
          () => {},
          () => {}
        );
      };
    },
    closeDialogView() {
      this.questionDialog.visible = false;
      this.loanhfcDialog.visible = false;
      this.entrepreneurDialog.visible = false;
      this.mortgageDialog.visible = false;
      this.priorityDialog.visible = false;
      this.caDialog.visible = false;
      this.installmentDialog.visible = false;
    },
    async loadFinanceCountInfo() {
      //取當日
      const date = new Date(), y = date.getFullYear(), m = date.getMonth();
      const firstDay = customFormatDate(new Date(y, m, 1), 'YYYY-MM-DD');
      const lastDay = customFormatDate(new Date(y, m+1, 0),'YYYY-MM-DD');
      const query = {
        agentId: this.isAdmin
          ? ""
          : this.getUserInfo.agentId
          ? this.getUserInfo.agentId
          : "",
        start: `${firstDay} 00:00:00`,
        end: `${lastDay} 23:59:59`,
      };
      console.log(query);

      this.fetchCountLoading = true;
      const res = await this.getFinanceCountInfo(query);
      this.fetchCountLoading = false;
      if (res && res.data) {
        const info = res.data.data;
        this.financeCountInfo.today = info.count;
        this.financeCountInfo.month = info.rangeCount;
      }
    },
    loanhfcEvent(type) {
      // 和潤 面板點擊事件
      console.log(`loanhfcEvent === ${type}`);
      if (type === 9) {
        const routeData = this.$router.resolve({
          path: "/EditCreditProduct",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            enable: false,
            agentId: this.getUserInfo.userId,
            editIndex: 0,
          },
        });
        window.open(routeData.href, "_blank");

      } else if (type === 3) {
        this.loanhfcDialog.visible = false;
        if (!this.editedItem.laonhfcInfo) {
          this.editedItem.laonhfcInfo = new LaonhfcModel();
        }
        if (!this.editedItem.paymentInfo) {
          this.editedItem.paymentInfo = new PaymentInfoModel();
        }
        if (!this.editedItem.caseInsure) {
          this.editedItem.caseInsure = new CaseInsureModel();
        }
        this.uploadMotorDialog = true;
      } else if (type === 4) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 10) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 1) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            caseVersion: 1,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 2) {
        const routeData = this.$router.resolve({
          path: "/CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 4,
            caseVersion: 2,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    entrepreneurEvent(type) {
      if (type === 6) {
        const routeData = this.$router.resolve({
          name: "EditCreditProduct",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 6,
            enable: false,
            agentId: this.getUserInfo.userId,
            editIndex: 0,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 10) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 6,
            isPrint: false,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (type === 11) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 6,
            isPrint: true,
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    caEvent(type) {
      if (type === 2) {
        const query = {
                    caseCategory: 2,
                    editIndex: 0,
                    caseId: this.editedItem.caseId,
                    enable: true,
            agentId: this.getUserInfo.userId,
            platform: 0,
            isFinance:1
        };
                // this.$router.push({ path: '/EditCreditProduct', query });
        let routeData = this.$router.resolve({ path: '/EditCreditProduct', query: query });
        window.open(routeData.href, '_blank');
      }

      if (type === 10) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: true,
            platform:this.editedItem.platform
          },
        });
        window.open(routeData.href, "_blank");
      }
      if (type === 11) {
        const routeData = this.$router.resolve({
          name: "CreditProductPrint",
          query: {
            caseId: this.editedItem.caseId,
            caseCategory: 2,
            isPrint: false,
            platform:this.editedItem.platform
          },
        });
        window.open(routeData.href, "_blank");
      }
    },
    handleLoadData() {
      this.loadData()
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/web/LoanhfcCreditList.vue